<div style="text-align: center;max-width: 500px;">
    <mat-card-title style="color: #1A47D6; margin-bottom: 50px; margin-top: 30px;">{{data.heading}}</mat-card-title>
    <p *ngFor="let line of data.text">{{line}}</p>
    <div>
        <button mat-stroked-button style="color: #1A47D6; border-color: #1A47D6; margin:20px 30px 20px auto; width: 25%;" (click)="cancel()">
            Cancel
        </button>
        <button mat-flat-button color="primary" style="background-color: #1A47D6; margin:20px auto 20px 30px;width: 25%;" (click)="confirm()">
            Confirm
        </button>
    </div>

</div>